export const CHAMADOS_CONFIG_DESIGN = {
    page: {
        container: "flex flex-col h-full w-full gap-6 p-2 md:p-0 animate-in fade-in slide-in-from-bottom-4 duration-500",
        header: {
            container: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4",
            title: "text-2xl font-bold text-gray-900 tracking-tight",
            subtitle: "text-sm text-gray-500 mt-1"
        },
        actionButton: "flex items-center gap-2 px-4 py-2.5 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-sm font-medium rounded-xl transition-all shadow-sm shadow-[#7C3AED]/20 active:transform active:scale-95"
    },
    stats: {
        grid: "grid grid-cols-2 md:grid-cols-4 gap-3",
        card: "bg-white rounded-xl border border-gray-100 p-4 flex items-center gap-3",
        iconBox: "w-10 h-10 rounded-xl flex items-center justify-center bg-violet-50",
        icon: "text-violet-600",
        value: "text-xl font-bold text-gray-900",
        label: "text-xs text-gray-500"
    },
    tabs: {
        list: "bg-gray-100/80 rounded-xl p-1",
        trigger: "rounded-lg data-[state=active]:bg-white data-[state=active]:shadow-sm text-sm font-medium px-4 py-2"
    },
    emptyState: {
        container: "flex flex-col items-center justify-center p-12 bg-white rounded-xl border border-gray-100 border-dashed text-center",
        iconBox: "w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mb-4 text-gray-400",
        title: "text-lg font-semibold text-gray-900 mb-1",
        description: "text-gray-500 max-w-sm mb-6",
        button: "text-[#7C3AED] font-medium hover:underline text-sm"
    },
    dialog: {
        paper: {
            borderRadius: '16px',
            padding: '16px',
            boxShadow: '0px 20px 40px -4px rgba(0, 0, 0, 0.1), 0px 8px 16px -4px rgba(0, 0, 0, 0.05)'
        },
        container: "px-2 pb-2",
        header: {
            sx: { p: 2, pb: 1, fontSize: '1.25rem', fontWeight: 700, color: '#111827' }
        },
        content: {
            sx: { p: 2, pt: '16px !important' },
            wrapper: "flex flex-col gap-5",
            section: {
                label: "block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2",
                input: {
                    sx: {
                        borderRadius: '12px',
                        backgroundColor: '#F9FAFB',
                        '& fieldset': { borderColor: '#E5E7EB' },
                        '&:hover fieldset': { borderColor: '#D1D5DB' },
                        '&.Mui-focused fieldset': { borderColor: '#7C3AED' },
                    }
                }
            },
        },
        actions: {
            sx: { p: 2, pt: 0 },
            cancelButton: "px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50 rounded-lg transition-colors",
            confirmButton: {
                base: "px-6 py-2 text-sm font-medium text-white rounded-lg transition-all shadow-sm",
                disabled: "bg-gray-300 cursor-not-allowed",
                active: "bg-[#7C3AED] hover:bg-[#6d28d9] shadow-[#7C3AED]/20"
            }
        }
    }
};
